import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH, TABLET_MIN_WIDTH } from '~/constants/common';

import backgroundImg from './assets/background.webp';
import backgroundMobileImg from './assets/mobile-background.webp';
import mobileQrLeft from './assets/mobile-left-qr.webp';
import mobileQrRight from './assets/mobile-right-qr.webp';

export const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  backgroundRepeat: 'no-repeat',
  padding: '100px 10px 97px',
  width: '100dvw',
  backgroundSize: 'cover',
  backgroundPosition: 'top right',
  alignItems: 'center',
  gap: '60px',
  flexDirection: 'column',
  backgroundImage: `url(${backgroundMobileImg})`,

  '& .mobile-left-qr': {
    backgroundImage: `url(${mobileQrLeft})`,
    width: '223px',
    height: '200px',
    position: 'absolute',
    bottom: 0,
    left: 0,
  },

  '& .mobile-right-qr': {
    backgroundImage: `url(${mobileQrRight})`,
    width: '180px',
    height: '106px',
    position: 'absolute',
    top: 0,
    right: 0,
  },

  [theme.breakpoints.up(TABLET_MIN_WIDTH)]: {
    '& .mobile-right-qr, & .mobile-left-qr': {
      display: 'none',
    },
    backgroundImage: `url(${backgroundImg})`,
    paddingBlock: '60px',
    backgroundPosition: 'top center',
  },

  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    paddingBlock: '40px',
    width: '100%',
  },
  [theme.breakpoints.down(TABLET_MIN_WIDTH)]: {
    paddingBlock: '60px',
    backgroundPosition: 'top center',
  },
}));

export const StyledTitles = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '15px',
    maxWidth: '874px',

    [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
      maxWidth: '600px',

      '.MuiTypography-root:last-child': {
        fontSize: '18px',
      },
    },
  };
});
